
import { breakpoints as _breakpoints, Size } from "@soluto-private/mx-asurion-ui-react-v3";

export const breakpoints = {
    ..._breakpoints,
    mdMax: `@media (max-width: ${Size.MD}px)`,
    md2Max: `@media (max-width: ${Size.MD2}px)`,
};
